import React, { Component } from 'react'
import { Col } from 'reactstrap';
import { Nav, Tab } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import {
  DropdownItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
// import { TodoModel } from '../../../Models/NotificationsModel/NotificationModel';
// import MessageChatWindowFC from '../MessageChatWindowFC';
// import MessageTextAreaFC from '../MessageTextAreaFC';
// import TaskHistory from './TaskHistory';
import { ReactComponent as FlagIcon } from "../../../../images/flagPlane.svg";
import { ReactComponent as FlaggedIcon } from "../../../../images/flag-yellow.svg";
import { ReactComponent as TaskIcon } from "../../../../images/task-icon-selected.svg";
import { ReactComponent as TaskInactiveIcon } from "../../../../images/task-icon.svg";
import { ReactComponent as HistoryIcon } from "../../../../images/history.svg";
import { ReactComponent as HistoryInactiveIcon } from "../../../../images/history-gray.svg";
import { ReactComponent as commentIcon } from "../../../../images/comment.svg";
import { ReactComponent as commentInactiveIcon } from "../../../../images/comment-gray.svg";
import CreateTodoForm from './CreateTodoForm';
import "./manualTodo.scss";
// import { catchError } from '../../../Utils/Utils';
// import SpinnerModel from '../../../commonFields/SpinnerModel';
// import { BankUserContext } from '../../../bankUserContext';
// import { MessageThread } from '../../../Models/MessageCenter/MessageThread';
// import { TodoHistoryDTO } from '../../../Models/Compliance/History';
// import CustomerService from '../../../Services/CustomerService';
import TaskHistory from './TaskHistory';
import { AxiosError, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { TodoHistoryDTO, TodoModel, manualTodoHistory } from '../../../../models/TodoModel';
import Service from '../../../../services';
import { BankUserContext } from '../../../../bankUserContext';
import { catchError } from '../../../../utils/Utils';
import SpinnerModel from '../../../../commonfields/SpinnerModel';

interface ITodoViewDetailsProps {
  todoViewDetailsModal: boolean;
  toggleViewDetails: () => void;
  todoViewLoader: boolean;
  toggleTodoViewLoader: (value?: boolean | undefined) => void;
  todoUuid: string;
  todoFlagged?: (element: TodoModel | null, priority: number) => void;
  handleStatusChange?: (todoUuid: TodoModel, status: string, reloadSingle?: boolean) => void;
  reloadComponent: boolean;
  selectedTodo: TodoModel;
  getTodo: any;
}

export enum TodoStatus {
  Open = "Open",
  In_Progress = "In_Progress",
  Completed = "Completed"
}

export enum ViewTabs {
  TaskDetailsTab = "TaskDetailsTab",
  MessagesTab = "MessageTabsTab",
  TaskHistoryTab = "TaskHistoryTab"
}

interface ITodoViewDetailsState {
  viewTodo: TodoModel | null;
  // messageThread: MessageThread | null;
  taskHistory: TodoHistoryDTO[] | [];
  todoStatusDropdown: boolean;
  todoStatusValue: TodoStatus | string;
  viewTab: ViewTabs;
  refreshCounter: number;
  documents: any;
  initialValues: any;

}

export default class TodoViewDetails extends Component<ITodoViewDetailsProps, ITodoViewDetailsState> {
  service = new Service();
  static contextType = BankUserContext;

  constructor(props: ITodoViewDetailsProps) {
    super(props);
    this.state = {
      viewTodo: null,
      // messageThread: null,
      taskHistory: [],
      todoStatusDropdown: false,
      todoStatusValue: "",
      viewTab: ViewTabs.TaskDetailsTab,
      refreshCounter: 0,
      initialValues: null,
      documents: []
    }
  }

  setViewTodo = (value: TodoModel | null) => this.setState({ viewTodo: value });

  toggleTodoStatusDropdown = () => this.setState({ todoStatusDropdown: !this.state.todoStatusDropdown });

  setViewTab = (value: ViewTabs) => this.setState({ viewTab: value });

  setRefreshCounter = () => this.setState({ refreshCounter: this.state.refreshCounter + 1 });

  setTodoStatusValue = (value: TodoStatus) => this.setState({ todoStatusValue: value })

  handleTodoStatus = (status: TodoStatus) => {
    this.setTodoStatusValue(status);
    if (this.state.viewTodo) {
      if (status === TodoStatus.Completed) {
        this.props.handleStatusChange ?
          this.props.handleStatusChange(this.state.viewTodo, status, false) :
          this.handleStatusChangeAlt(this.props.todoUuid, status);
        this.props.toggleViewDetails();
      } else {
        this.props.handleStatusChange ?
          this.props.handleStatusChange(this.state.viewTodo, status, false) :
          this.handleStatusChangeAlt(this.props.todoUuid, status);
      }
    } else {
      catchError("Something Went Wrong", true)
    }
  }

  getTodoById = (displayLoader = true) => {
    displayLoader && this.props.toggleTodoViewLoader();
    const data = {
      "screen": "LandingPage",
      "sections": "GetTodoById",
      "todoUuid": this.props.selectedTodo.todoUuid,
      "isJsonReturnObject": false
    }

    this.service.getTodoById(data)
      .then((res: AxiosResponse<TodoModel[]>) => {
        if (res.data?.length > 0) {
          this.setState({ viewTodo: res?.data[0] })
        }
        this.setTodoStatusValue(res?.data?.[0].status)
      })

      .catch((err: AxiosError) => catchError(err, true))
      .finally(() => displayLoader && this.props.toggleTodoViewLoader());
  }

  todoFlaggedAlt = (todoUuid: string, unflagTodo: boolean) => {
    this.props.toggleTodoViewLoader(true);
    // this.service.markTodoAsFlagged(todoUuid, unflagTodo)
    //   .then((response: AxiosResponse<string>) => {
    //     toast.success(`${response.data}`, {
    //       position: toast.POSITION.TOP_RIGHT,
    //     });
    //     this.getTodoById();
    //   })
    //   .catch((err) => catchError(err, true))
    //   .finally(() => this.props.toggleTodoViewLoader(false));
  }

  handleStatusChangeAlt = (todoUuid: string, status: TodoStatus) => {
    // this.service.todoStatusChange(todoUuid, status)
    //   .then((response: AxiosResponse<string>) => {
    //     toast.success(response.data);
    //     this.getTodoById();
    //   })
    //   .catch((err) => catchError(err, true));
  }

  getMessageThreads = (contextId?: string | null) => {
    // contextId && this.service.getMessageThreadByContextId(contextId)
    //   .then((res: AxiosResponse<MessageThread>) => this.setState({ messageThread: res?.data }))
    //   .catch((err) => catchError(err,true));
  };


  getManualTodoHistory = (element: TodoModel) => {
    // if(element.referenceId){
    //   this.service.getTaskHistory(element.referenceId)
    //   .then((res) => {
    //     console.log("res",res.data)
    //     const sortedResults = res?.data?.sort((a: TodoHistoryDTO, b: TodoHistoryDTO) => {
    //       return (
    //         moment(b.updatedDate).diff(moment(a.updatedDate), 'seconds')
    //       );
    //     })
    //     this.setState({ taskHistory: sortedResults })
    //   })
    //   .catch((err) => catchError(err, true));
    // }
    if (element.isManual) {
      const data = {
        "screen": "LandingPage",
        "sections": "getManualTodoHistory",
        "todoUuid": element.todoUuid,
        "isJsonReturnObject": false
      }

      this.service.getManualTodoHistory(data).then((response: AxiosResponse<manualTodoHistory[]>) => {
        const modifyingResponse = response.data.map((m: any) => {
          return {
            todoHistoryId: m.todoHistoryId, createdByName: m.updatedByName, updatedDate: m.updatedDate,
            date: m.date,
            time: m.time,
            taskInfo: m.todoIfo
          }

        })
        const sortedResults = modifyingResponse.sort((a: any, b: any) => {
          return (
            moment(b.updatedDate).diff(moment(a.updatedDate), 'seconds')
          );
        })
        this.setState({ taskHistory: sortedResults })
      })
    }

  }

  componentDidMount = () => {
    this.getTodoById();
    this.setInitialValues();
  }

  setInitialValues = () => {
    let data = [];
    if (this.state.documents && this.state.documents.length > 0) {
      data = JSON.parse(this.state.documents)?.map((m: any) => {
        return { ...m, path: m.documentUniqueId, name: m.documentName }
      })
    }

    const initialValues = {
      todoType: this.props?.selectedTodo?.todoTypeId,
      todoDescription: this.props?.selectedTodo?.todoDescription,
      notes: this.props?.selectedTodo?.notes,
      documents: data
    }

    this.setState({ initialValues: initialValues })

  }

  componentDidUpdate = (prevProps: Readonly<ITodoViewDetailsProps>, prevState: Readonly<ITodoViewDetailsState>) => {
    if (prevProps.reloadComponent !== this.props.reloadComponent) {
      this.getTodoById();
      this.setInitialValues();
    }
  }

  render() {

    return (
      <div className='todoViewDetails'>
        <Modal
          className="todoViewDetailsModal"
          isOpen={this.props.todoViewDetailsModal}
          fade={false}
          toggle={this.props.toggleViewDetails}
        >
          {
            <>
              {this.state.viewTodo?.priority === 2 && <div className="flagHeader"></div>}
              <ModalHeader toggle={this.props.toggleViewDetails}>
                <div className="todoHeader">
                  <div className="todoDropdown">
                    <Dropdown
                      className={`toDoStatusDropdown ${this.state.todoStatusValue}`}
                      toggle={() => this.toggleTodoStatusDropdown()}
                      isOpen={this.state.todoStatusDropdown}
                      disabled={this.state.todoStatusValue === TodoStatus.Completed}
                    >
                      <DropdownToggle>
                        {this.state.todoStatusValue?.split("_").join(" ")}
                      </DropdownToggle>
                      <DropdownMenu container="body" className="toDoStatusList">
                        <DropdownItem onClick={() => this.handleTodoStatus(TodoStatus.Open)}>
                          {this.state.todoStatusValue === TodoStatus.Open ? "Open" : "Todo"}
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => this.handleTodoStatus(TodoStatus.In_Progress)}>
                          In Progress
                        </DropdownItem>
                        <DropdownItem onClick={() => this.handleTodoStatus(TodoStatus.Completed)}>
                          Completed
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>

                  <div className="todoTitle">
                    {this.props.selectedTodo?.todoTypeId == 5 ? this.props.selectedTodo?.caseCode + " - " + this.props.selectedTodo?.todoDescription
                      : this.props.selectedTodo?.todoDescription}
                  </div>

                  <div className="todoFlag">
                    {
                      this.state.viewTodo?.priority === 2 ? (
                        <div
                          className='flagged'
                          onClick={() =>
                            this.state.todoStatusValue !== TodoStatus.Completed &&
                              this.props.todoFlagged ?
                              this.props.todoFlagged(this.state.viewTodo, 3) :
                              this.todoFlaggedAlt(this.props.todoUuid, true)
                          }
                        >
                          <FlaggedIcon /> Flagged as Important
                        </div>
                      ) : (
                        <div
                          className='flag'
                          onClick={() =>
                            this.state.todoStatusValue !== TodoStatus.Completed &&
                              this.props.todoFlagged ?
                              this.props.todoFlagged(this.state.viewTodo, 2) :
                              this.todoFlaggedAlt(this.props.todoUuid, false)
                          }
                        >
                          <FlagIcon /> Flag as Important
                        </div>
                      )
                    }
                  </div>
                </div>
              </ModalHeader>
              <ModalBody>
                <div className="todoViewDetailsBody">
                  <Tab.Container defaultActiveKey={ViewTabs.TaskDetailsTab} >
                    <Col className="navLinksSearch" md="12">
                      <Nav variant="tabs" >
                        <Nav.Item>
                          <Nav.Link
                            eventKey={ViewTabs.TaskDetailsTab}
                            onClick={() => this.setViewTab(ViewTabs.TaskDetailsTab)}
                          >
                            {
                              this.state.viewTab === ViewTabs.TaskDetailsTab ?
                                <TaskIcon /> :
                                <TaskInactiveIcon />
                            } Task Details
                          </Nav.Link>{" "}
                        </Nav.Item>
                        {/* {
                          this.state.viewTodo?.createdUserUuid !== 
                          this.context.bankuserDetails?.userUuid &&
                          <Nav.Item >
                          <Nav.Link 
                            eventKey={ViewTabs.MessagesTab} 
                            onClick={() => {
                              this.setViewTab(ViewTabs.MessagesTab);
                              this.state.viewTodo && this.getMessageThreads(this.state.viewTodo.contextId);
                              this.setRefreshCounter();
                            }}
                          >
                            { 
                              this.state.viewTab === ViewTabs.MessagesTab ? 
                                <img src={commentIcon} /> :
                                <img src={commentInactiveIcon} />
                            } Messages
                          </Nav.Link>{" "}
                        </Nav.Item>
                        } */}
                        <Nav.Item >
                          <Nav.Link eventKey={ViewTabs.TaskHistoryTab}
                            onClick={() => {
                              this.setViewTab(ViewTabs.TaskHistoryTab);
                              this.state.viewTodo && this.getManualTodoHistory(this.state.viewTodo);
                            }}
                          >
                            {
                              this.state.viewTab === ViewTabs.TaskHistoryTab ?
                                <HistoryIcon /> :
                                <HistoryInactiveIcon />
                            } Task History
                          </Nav.Link>{" "}
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col>
                      <Tab.Content>
                        <Tab.Pane
                          eventKey={ViewTabs.TaskDetailsTab}
                          onClick={() => this.setViewTab(ViewTabs.TaskDetailsTab)}
                        >
                          <CreateTodoForm
                            viewTodo={this.props.selectedTodo}
                            viewTodoLoader={this.props.todoViewLoader}
                            setViewTodoLoader={this.props.toggleTodoViewLoader}
                            getTodoById={this.getTodoById}
                            getTodo={this.props.getTodo}
                            disableFields={this.state.viewTodo?.status === TodoStatus.Completed}
                            fromViewDetails={true}
                            initialValues={this.state.initialValues}
                          />
                        </Tab.Pane>
                        {/* {
                      this.state.viewTodo?.createdUserUuid !== 
                      this.context.bankuserDetails?.userUuid &&
                      <Tab.Pane eventKey={ViewTabs.MessagesTab}>
                        <div className="message-modal">
                          { 
                            <>
                              <MessageChatWindowFC
                                messageThread={this.state.messageThread} 
                                refreshCounter={this.state.refreshCounter}
                              />
                              { 
                                this.state.viewTodo?.status === TodoStatus.Completed ?
                                <h6 className='blockMessages'>
                                  Messages displayed here are read only, as the todo was completed already.
                                </h6> : 
                                <MessageTextAreaFC
                                  messageThread={this.state.messageThread} 
                                  todo={this.state.viewTodo}
                                  setRefreshCounter={this.setRefreshCounter}
                                  getMessageThreads={this.getMessageThreads}
                                  setViewTodo={this.setViewTodo}
                                />
                              }
                            </>
                          }
                        </div>
                      </Tab.Pane>
                    } */}
                        <Tab.Pane eventKey={ViewTabs.TaskHistoryTab}>
                          <TaskHistory taskHistory={this.state.taskHistory} />
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Tab.Container>
                </div>
              </ModalBody>
            </>
          }

        </Modal>
      </div>
    )
  }
}
